export enum Sentiment {
  POSITIVE = 'pos',
  NEUTRAL = 'neu',
  NEGATIVE = 'neg',
}

export enum CallStatus {
  RESOLVED = 'COMPLETED',
  TRANSFERRED = 'TRANSFERED',
  MESSAGE_TAKEN = 'MESSAGE',
  UNRESOLVED = 'HANGUP',
  INCOMPLETE = 'ONGOING',
  UNKNOWN = 'UNKNOWN',
}

export enum MessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  SYSTEM = 'system',
  TOOL = 'tool',
}

export enum Event {
  NO_EVENT = 'no event',
  SPAM = 'spam',
  INCOMPLETE_UTTERANCE = 'incomplete utterance',
  END_CONVERSATION = 'end conversation',
}

export enum ToolFunctionType {
  END_CONVERSATION = 'OpenvoiceEndConversation',
  SEND_MESSAGE = 'OpenvoiceSendMessage',
  TRANSFER_CALL = 'OpenvoiceTransferCall',
}

export interface IReportCallParams {
  start_date: string;
  end_date: string;
  page: number;
  size: number;
}

export interface IReportCallStatsParams {
  start_date: string;
  end_date: string;
}

export interface ICallStats {
  num_call: number;
  avg_call_duration: number;
  num_message: number;
  num_complete: number;
  sentiment: ICallSentiment;
}

export interface ICallSentiment {
  neg: number;
  neu: number;
  pos: number;
  compound?: number;
}

export interface IMessageToolCall {
  type: string;
  function: {
    name: ToolFunctionType;
    arguments: string;
  };
}

export interface IMessage {
  role: MessageRole;
  content: string;
  sentiment_scores: ICallSentiment;
  tool_calls?: IMessageToolCall[];
  timestamp: number;
  record_transcript?: boolean;
  event?: Event;
}

export interface ICalls {
  items: ICall[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface ICall {
  id: string;
  participant: {
    type?: string;
    phone_number: string;
    direction?: string;
    call_sid?: string;
  };
  events?: {
    call_started: string;
    call_ended: string;
  };
  start_time: string;
  duration: number;
  resolution: string;
  call_sid?: string;
  sentiment: ICallSentiment;
}

export interface ICallDetails {
  id: string;
  agent_id: number;
  participant: {
    type: string;
    phone_number: string;
    direction: string;
    call_sid: string;
  };
  messages: IMessage[];
  events: {
    call_started: string;
    call_ended: string;
  };
  summary: {
    action: string[] | string;
    discussion: string[] | string;
    summary: string[] | string;
  };
  audio_recording_filepath: string;
  start_time: string;
  duration: number;
  resolution: string;
  call_sid: string;
  sentiment: ICallSentiment;
  user_data: {};
}
